import React, {h} from 'preact';
import SellContactFormStep from './SellContactFormStep';

function trackInactivity(callback, timeout) {
    let time;
    let stoppedTracking = false;
    window.onload = resetTimer;
    document.onmousemove = resetTimer;
    document.onkeydown = resetTimer;

    function resetTimer() {
        if (!stoppedTracking) {
            clearTimeout(time);
            time = setTimeout(callback, timeout);
        }
    }
    function stopTracking() {
        time = null;
        stoppedTracking = true;
    }

    resetTimer();

    return stopTracking;
}

export default class SellContactFormStep1 extends SellContactFormStep {
    componentDidMount() {
        if (this.props.realtorId) {
            let data = {
                'dlink': this.props.dlink,
                'tag': this.props.tag,
                'prop.address': this.props.address,
                'email': this.props.email,
                'name': this.props.name,
                'phone': this.props.phone
            };
            this.props.parent.submitPromise = $.post('api/submitRequestDirect-json', data).then(data => {
                data = {...data, ...data.req};

                if (data.msg) {
                    window.location = 'index?msg=' + encodeURI(data.msg);
                    return;
                }
                if (data.redirectUrl) {
                    window.location = data.redirectUrl;
                    return;
                }
                trackSellRequestConversion(data, !!this.props.phone ? null : +phonelessConversionPct);
                trackEvent('Flow', data.requestId, 'sellV3Step3Chat')
                    .withOptimizely()
                    .withGA();
                this.props.parent.requestId = data.requestId;
                return data;
            });
            this.props.parent.submitPromise.then(data => {
                $.post('sellerInviteAgent-json?', {requestId: data.requestId, realtorId: this.props.realtorId});
            });
            this.props.parent.setState({currentStep: 'SELL_CHAT'});
            trackEvent('Flow', 'SellRequest', 'sellV3Step2cName')
                .withOptimizely()
                .withGA();
            this.triggerEvent();
            return;
        }

        trackEvent('Flow', 'SellRequest', 'sellV3Step2cName', {
            abTestWHYVersion: window.abTestWHYVersion
        })
            .withOptimizely()
            .withGA();

        trackEvent('Flow', 'SellRequest', 'sellerRequestStep5PageLoad', {
            abTestWHYVersion: window.abTestWHYVersion
        })
            .withGA()
            .withOptimizely();

        $('#flow-container .float-label-div').initFloatLabels();

        this.assignAddressUpdateHandler();

        this.validator = $(this.refs.form).validate({
            rules: {
                name: {
                    minlength: 5,
                    minWords: 2,
                    pattern: "[A-Za-z\u0300-\u0315-.,'’ ]+"
                }
            },
            messages: {
                name: {
                    minlength: jQuery.format('Please enter at least {0} characters'),
                    minWords: jQuery.format('Please enter your first and last name.'),
                    pattern: jQuery.format(
                        "Only A-Z, a-z, comma, apostrophe, period and hyphen ( , ' ’ . - ) are allowed."
                    )
                },
                unit: {
                    required: 'Unit # is required.'
                },
                phone: {
                    phoneUS: 'Please specify a valid 10-digit phone number.'
                }
            },
            invalidHandler: (form, validator) => {
                validator.focusInvalid();
                this.highlightValidationErrors(validator.errorList);
                this.trackValidationError();
                this.notifyOnValidationErrorThrottled();
            }
        });

        if (this.props.address) {
            this.validateAddress();
        }

        if (this.props.loggedInUser) {
            $(this.refs.name)
                .val(this.props.loggedInUser.name)
                .trigger('input');
            $(this.refs.email)
                .val(this.props.loggedInUser.email)
                .trigger('input');
            $(this.refs.phone)
                .val(this.phoneFormat(this.props.loggedInUser.phone))
                .trigger('input');
            this.setState({isPhoneVisible: true});
        }
        if (window.abTestWHYVersion == 'B') {
            this.stopTracking = trackInactivity(this.handleNameHighlight, 5000);
        }
    }

    componentWillUnmount() {
        this.stopTracking && this.stopTracking();
    }

    handleNameHighlight = () => {
        if (this.refs.name && !$(this.refs.name).valid()) {
            $(this.refs.name)
                .parents('.float-label-div')
                .addClass('error');
            this.setState(currentState => ({
                errors: {
                    ...currentState,
                    name:
                        'Why are we asking this? A name will allow us to confirm ownership as well as allow you to re-login to see your Agent Proposals'
                }
            }));
        }
        trackEvent('Flow', 'SellRequest', 'abTestWHYInactivity')
            .withGA()
            .withOptimizely();
        this.stopTracking();
    };

    nextStep = throttleByPromise(() => {
        if (!$(this.refs.form).valid()) {
            this.trackValidationError();
            this.notifyOnValidationErrorThrottled();
            return;
        }
        let name = $(this.refs.name).val();
        let address = $(this.refs.address).val();

        this.validateAddress();

        this.validationPromise.then(validationResult => {
            if (validationResult && validationResult.msg) {
                $(this.refs.addressBlock)
                    .find('label.error')
                    .remove();
                if ($(this.refs.addressBlock).find('label.error').length === 0) {
                    $(this.refs.address).after(
                        $('<label for="address" generated="true" class="error from-server"/>').html(
                            validationResult.msg
                        )
                    );
                }
                this.trackValidationError(validationResult.rejectReason || 'address');
                this.notifyOnValidationErrorThrottled();
                return;
            }

            trackEvent('Flow', 'SellRequest', 'sellerRequestStep5ClickedContinue', {
                abTestWHYVersion: window.abTestWHYVersion
            })
                .withGA()
                .withOptimizely();

            this.props.parent.setState({name, address, currentStep: 'SELL_CONTACT_FORM2'});
        });
    });

    render() {
        const {errors} = this.state;

        if (this.props.realtorId) {
            return (
                <i
                    className="fa fa-spinner fa-pulse"
                    style="color:#aaa;font-size:70px;margin:200px auto 0;position:relative;text-align:center;width:100%"
                />
            );
        } else {
            return (
                <div id="sell-flow-step5" className="flow-step">
                    <div id="contact-form-top-text">
                        <img src={this.props.amPhoto} className="img-circle pull-left mobile-buy-sell-flow-ua-img" />
                        <div>Our service is 100% free with no strings attached.</div>
                    </div>
                    <div className="flow-step-header-text">
                        <strong>Let&apos;s find out how much you can save on your home.</strong>
                    </div>

                    <form ref={elem => (this.refs.form = elem)}>
                        <div className="float-label-div" style={{position: 'relative'}}>
                            <input
                                ref={elem => (this.refs.name = elem)}
                                id="name"
                                name="name"
                                className="required"
                                minwords="2"
                                minLength="5"
                                maxLength="100"
                                autoComplete="name"
                                onBlur={() => this.handleValidation(this.refs.name)}
                            />
                            <label htmlFor="name" className="float-label required">
                                First and last name
                            </label>
                            <i className="contact-form-icon icon-profile-outline" />
                            {!!errors.name && (
                                <label htmlFor="name" generated="true" className="error">
                                    {errors.name}
                                </label>
                            )}
                        </div>
                        {!this.props.parent.state.alsoBuying && [
                            <div
                                ref={elem => (this.refs.addressBlock = elem)}
                                className="float-label-div"
                                style={{position: 'relative'}}>
                                <input
                                    className="required validStreetCityState"
                                    ref={elem => (this.refs.address = elem)}
                                    id="address"
                                    name="address"
                                    placeholder=""
                                    value={this.props.address}
                                    autoComplete="street-address"
                                    onBlur={() => this.validateAddress()}
                                />
                                <label htmlFor="address" className="float-label required">
                                    Property address
                                </label>
                                <i className="contact-form-icon icon-location-outline" />
                                {!!errors.address && (
                                    <label htmlFor="name" generated="true" className="error">
                                        {errors.address}
                                    </label>
                                )}
                            </div>,
                            ['Condominium', 'Townhouse'].includes(this.props.parent.state.homeType) ? (
                                <div className="float-label-div">
                                    <input
                                        maxLength="5"
                                        ref={elem => (this.refs.unit = elem)}
                                        id="unit"
                                        name="unit"
                                        placeholder=""
                                        className={this.props.parent.state.homeType === 'Condominium' ? 'required' : ''}
                                        onBlur={() =>
                                            $(this.refs.unit).valid() || this.notifyOnValidationErrorThrottled()
                                        }
                                    />
                                    <label
                                        htmlFor="unit"
                                        className={
                                            this.props.parent.state.homeType === 'Condominium'
                                                ? 'float-label required'
                                                : 'float-label'
                                        }>
                                        Unit #
                                    </label>
                                    <i className="contact-form-icon icon-menu_requests" />
                                </div>
                            ) : null
                        ]}
                    </form>

                    <button
                        type="button"
                        className={
                            window.SPLIT_CONTACT_FORM_STEP
                                ? 'continue-button split-contact-form-button'
                                : 'continue-button'
                        }
                        onClick={() => {
                            this.nextStep();
                        }}>
                        Continue
                    </button>
                    <div className="flow-spacer" />
                </div>
            );
        }
    }
}
